import React, { useMemo } from 'react';
import { TemplateContinue } from '../../components/TemplateContinue';
import CircledX from '../../assets/CircledX';
import { useOpts } from '../../context';
import getJobResultErrorMessageArray from '../utils/get-job-result-error-message-array';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
export var ErrorImage = function () { return (React.createElement("div", null,
    React.createElement(CircledX, { size: 80, color: "#4D5E73" }))); };
/**
 * This component is used to show the error screen.
 */
var Error = function () {
    var getLocalizedString = useGetLocalizedString();
    var _a = useOpts(), exit = _a.exit, linkApiJobResults = _a.linkApiJobResults;
    var buttonLabel = useMemo(function () { return getLocalizedString('CLOSE'); }, [getLocalizedString]);
    var errorMessages = getJobResultErrorMessageArray(linkApiJobResults);
    if (!errorMessages)
        return null;
    var title = errorMessages[0], subtitle = errorMessages.slice(1);
    return (React.createElement(TemplateContinue, { Image: ErrorImage, title: title, subtitle: subtitle.join('\n'), buttonLabel: buttonLabel, buttonEventId: "Error-continue", onContinue: function () { return exit(); }, dataTestId: "ErrorFeedback" }));
};
export default Error;
